module.exports = __webpack_public_path__ + "img/sales.e4ccebe5.svg";